import { useI18nContext } from './I18nProvider'
import type { Locale } from './types'

/**
 * useTranslation(namespace)
 *
 * Returns a `t(key, vars?)` function scoped to the given feature namespace.
 * Keys are flat dot-separated strings: "auth.form.email.label"
 * Vars are replaced with {{varName}} syntax: t("dashboard.count", { n: 5 })
 *
 * Falls back to the key itself when a translation is missing.
 */
export function useTranslation(namespace: string) {
  const { locale, setLocale, registry } = useI18nContext()
  const ns = registry[namespace]?.[locale] ?? {}

  function t(key: string, vars?: Record<string, string | number>): string {
    let value = ns[key] ?? key
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        value = value.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v))
      })
    }
    return value
  }

  return { t, locale, setLocale }
}

export type { Locale }
export type TranslateFn = (key: string, vars?: Record<string, string | number>) => string
